import { Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom";
import { useTranslation } from "react-i18next";
import ManageOutgoingMailcontainer from "../../../containers/ManageOutgoingMailsContainer/ManageOutgoingMailsContainer";

const ManageOutgoingMail = () => {
  const tRP = "components.outgoing_mail";
  const { t } = useTranslation();
  const [portalHeader, setPortalHeader] = useState<HTMLElement | null>(null);

  useEffect(() => {
    setPortalHeader(document.getElementById("Title-screen"));
  }, []);

  return (
    <>
      {portalHeader &&
        ReactDOM.createPortal(
          <>
            <Typography
              variant="h3"
              sx={{
                display: "-webkit-box",
                WebkitLineClamp: "2",
                WebkitBoxOrient: "vertical",
                overflow: "hidden",
              }}
            >
              {`${t(`${tRP}.title`)}`}
            </Typography>
          </>,
          portalHeader
        )}
      <ManageOutgoingMailcontainer />
    </>
  );
};

export default ManageOutgoingMail;
